import type { TFunction } from 'i18next';
import type { ComponentType, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { typography } from '@adflow/frontend/ui-theme';

import type { ToastType } from './toast-type';

export interface ToastContentProps {
	TitleComponent: ComponentType<{ t: TFunction }>;
	message: ReactNode;
	type: ToastType;
}

export function ToastContent({
	TitleComponent,
	message,
	type,
}: ToastContentProps) {
	const { t } = useTranslation(['common']);

	return (
		<div data-toast={type}>
			<h1
				css={[
					typography.title,
					{ color: 'inherit' },
					message && { marginBottom: '0.5rem' },
				]}
			>
				<TitleComponent t={t} />
			</h1>
			<div
				css={[typography.regular, { color: 'inherit', whiteSpace: 'pre-wrap' }]}
			>
				{message}
			</div>
		</div>
	);
}
